const isFile = (value) => value instanceof File

export function appendVideoFormData(formData, videoList, isUpdate, detailIDField) {
  let itemsToSave = []
  let ids = []

  if (!isUpdate) {
    itemsToSave = videoList.filter((item) => item.VideoURL)
  } else {
    const updatedItems = []
    const addedItems = []
    const removedItems = []

    videoList.forEach((item) => {
      if (item.IsRemoved && item[detailIDField]) removedItems.push(item)
      else if (item[detailIDField]) updatedItems.push(item)
      else if (item.VideoURL) addedItems.push(item)
    })

    itemsToSave = [...updatedItems, ...addedItems]
    ids = [...updatedItems, ...removedItems].map((item) => item[detailIDField])
  }

  formData.append("VideoPaths", itemsToSave.map((item) => item.VideoURL || "").join(","))

  // Build: binary1 , binary2 , binary3 ... as ONE blob (same order as VideoPaths)
  const parts = []

  itemsToSave.forEach((item, index) => {
    if (index > 0) parts.push(",")
    if (isFile(item.ThumbnailFile)) {
      parts.push(item.ThumbnailFile)
    }
  })

  // A filename makes it a single file part ("binary") instead of a text field
  formData.append(
    "ThumbnailPaths",
    new Blob(parts, { type: "application/octet-stream" }),
    "ThumbnailPaths.bin"
  )

  if (isUpdate) {
    formData.append(detailIDField, ids.join(","))
  }
}